import { PrivateBillCostCenter } from "@/Common/Components/Billing/PrivateBillCostCenter";
import { Site } from "@/Common/Models/Sites/ResponseModels/Site";

type Model = "Model";
type CostCenters = "CostCenters";

interface ISiteViewModel {
    get(key: Model): Site;
    set(key: Model, value: Site): this;

    get(key: CostCenters): Immutable.List<PrivateBillCostCenter>;
    set(key: CostCenters, value: Immutable.List<PrivateBillCostCenter>): this;
}

class SiteViewModel {
    public static getDefault(): any {
        return Immutable.fromJS({
            Model: new Site,
            CostCenters: []
        });
    }
}

export { ISiteViewModel, SiteViewModel };
